module.exports = __webpack_public_path__ + "static/media/DB-1538_58x58x58_GZZ_3X.013071da.tom";